// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cbc0ba00","946":"7d939c1a"}[chunkId] + ".chunk.js";
};